import { __decorate } from "tslib";
import { __metadata } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { AppState } from "../../../app.service";
import { BankAccount } from "@api/endpoints";
import { TrackingError } from "@api/services/tracking";
var BankAccountComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function BankAccountComponent(appState) {
        this.appState = appState;
        this.scrollToErrorMsg = new EventEmitter();
        /**
         * Set our default values
         */
        this.localState = { value: "" };
        /**
         * Form values
         */
        this.name = "";
        this.iban = "";
        this.bic = "";
        this.bank = "";
        this.accepted = "";
        this.bankAccount = "";
        this.bankIdentifier = "";
        this.generatedIban = "";
        this.generatedBic = "";
        this.generatedBankName = "";
        this.bankConfirmed = false;
        /**
         * Error vars
         */
        this.nameError = false;
        this.ibanError = false;
        this.bicError = false;
        this.bankError = false;
        this.acceptedError = false;
        this.bankAccountError = false;
        this.bankIdentifierError = false;
        /**
         * Helpers
         */
        this.patterns = {
            NUMERIC: /^\d+$/,
            STRING: /^[a-zA-ZàáâäãåacceèéêëeiìíîïlnòóôöõøùúûüuuÿýzzñçcszÀÁÂÄÃÅACCEEÈÉÊËÌÍÎÏILNÒÓÔÖÕØÙÚÛÜUUYÝZZÑßÇOÆCSZð &!?,‚.:'\-\(\)\/]+$/,
            EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            ALPHANUMERIC: /^\d+[a-zA-Z]*$/,
            STRING_NUMERIC: /^[0-9a-zA-ZàáâäãåacceèéêëeiìíîïlnòóôöõøùúûüuuÿýzzñçcszÀÁÂÄÃÅACCEEÈÉÊËÌÍÎÏILNÒÓÔÖÕØÙÚÛÜUUYÝZZÑßÇOÆCSZ?ð &!?,.:'\-\(\)\/]+$/,
            STRING_NUMERIC_ONLY: /^([0-9a-zA-Z]{6,10})$/,
        };
    }
    BankAccountComponent.prototype.ngOnInit = function () {
        window.vf.overlay.init();
    };
    BankAccountComponent.prototype.submitForm = function () {
        if (this.validate()) {
            this.onBankAccountSubmit({
                name: this.name,
                iban: this.iban,
                bic: this.bic,
                bank: this.bank,
                accepted: this.accepted,
                bankAccount: this.bankAccount,
                bankIdentifier: this.bankIdentifier,
            });
        }
        else {
            this.scrollToErrorMsg.emit();
        }
    };
    BankAccountComponent.prototype.validate = function () {
        this.resetValidator();
        var errors = 0;
        var tracking = new TrackingError();
        if (!this.patterns.STRING_NUMERIC.test(this.name) ||
            this.name.length < 1 ||
            this.name.length > 50) {
            errors++;
            this.nameError = true;
            tracking
                .setType("validation")
                .setMessage("Bank: Invalid name")
                .setLocation("checkout")
                .track();
        }
        if (!this.patterns.STRING_NUMERIC.test(this.iban) ||
            this.iban.length < 22 ||
            this.iban.length > 35) {
            errors++;
            this.ibanError = true;
            tracking
                .setType("validation")
                .setMessage("Bank: Invalid iban")
                .setLocation("checkout")
                .track();
        }
        if (!this.patterns.STRING_NUMERIC.test(this.bic) ||
            this.bic.length < 8 ||
            this.bic.length > 11) {
            errors++;
            this.bicError = true;
            tracking
                .setType("validation")
                .setMessage("Bank: Invalid bic")
                .setLocation("checkout")
                .track();
        }
        if (!this.patterns.STRING_NUMERIC.test(this.bank) ||
            this.bank.length < 1 ||
            this.bank.length > 50) {
            errors++;
            this.bankError = true;
            tracking
                .setType("validation")
                .setMessage("Bank: Invalid bank")
                .setLocation("checkout")
                .track();
        }
        if (this.accepted !== "yes") {
            errors++;
            this.acceptedError = true;
            tracking
                .setType("validation")
                .setMessage("Bank: SEPA Agreement was not accepted")
                .setLocation("checkout")
                .track();
        }
        return errors === 0;
    };
    BankAccountComponent.prototype.resetValidator = function () {
        this.nameError = false;
        this.ibanError = false;
        this.bicError = false;
        this.bankError = false;
        this.acceptedError = false;
    };
    BankAccountComponent.prototype.openIbanHelper = function ($event) {
        $event.preventDefault();
        window.vf.overlay.openOverlayDirect("iban-helper");
    };
    BankAccountComponent.prototype.requestIban = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.resetIbanValidator();
                        return [4 /*yield*/, BankAccount.post({
                                bankIdentifier: this.bankIdentifier,
                                accountNumber: this.bankAccount,
                            })];
                    case 1:
                        response = _a.sent();
                        if (response.getResponse().responseCode !== "Ba.Po.200.0") {
                            this.bankAccountError = true;
                        }
                        else {
                            this.bankConfirmed = true;
                            this.generatedIban = response.getResponse().bankaccount.iban;
                            this.generatedBic = response.getResponse().bankaccount.bic;
                            this.generatedBankName =
                                response.getResponse().bankaccount.bankName;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BankAccountComponent.prototype.submitIban = function () {
        this.iban = this.generatedIban;
        this.bic = this.generatedBic;
        this.bank = this.generatedBankName;
        this.generatedIban = "";
        this.generatedBic = "";
        this.generatedBankName = "";
        this.bankConfirmed = false;
        jQuery("body").removeClass("no-scroll");
        jQuery("body").find("#iban-helper").fadeOut();
    };
    BankAccountComponent.prototype.retry = function () {
        this.bankConfirmed = false;
    };
    BankAccountComponent.prototype.resetIbanValidator = function () {
        this.bankAccountError = false;
        this.bankIdentifierError = false;
    };
    BankAccountComponent.prototype.handleIbanChange = function () {
        var _this = this;
        clearTimeout(this.timeoutListener);
        this.timeoutListener = setTimeout(function () {
            return __awaiter(_this, void 0, void 0, function () {
                var response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, BankAccount.post({
                                iban: this.iban,
                            })];
                        case 1:
                            response = _a.sent();
                            if (response.getResponse().responseCode !== "Ba.Po.200.0") {
                                this.ibanError = true;
                            }
                            else {
                                this.ibanError = false;
                                this.bic = response.getResponse().bankaccount.bic;
                                this.bank = response.getResponse().bankaccount.bankName;
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }, 500);
    };
    return BankAccountComponent;
}());
export { BankAccountComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/checkout-form/bank-account/bank-account.component.ts
// module id = null
// module chunks = 